import axios from 'axios'
import { make } from 'vuex-pathify'
import { getQueryFromFilter, showError, showSuccess } from '@/util/helpers'

const state = { current: null, loading: false, saving: false }
const mutations = make.mutations(state)
const endpoint = reportKey => `${process.env.VUE_APP_API_URL}/report-personalizations/${encodeURIComponent(reportKey)}?${getQueryFromFilter({})}`

const actions = {
  async get ({ state }, reportKey) {
    state.loading = true
    try {
      const { data } = await axios.get(endpoint(reportKey))
      state.current = data
      return data
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.loading = false
    }
  },
  async save ({ state }, { reportKey, layout }) {
    state.saving = true
    try {
      const { data } = await axios.put(endpoint(reportKey), layout)
      showSuccess('Personalização do relatório salva.')
      return data
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.saving = false
    }
  },
  async restore ({ state }, reportKey) {
    state.saving = true
    try {
      const { data } = await axios.delete(endpoint(reportKey))
      showSuccess('Relatório restaurado para o padrão.')
      return data.layout
    } catch (error) {
      showError(error)
      throw error
    } finally {
      state.saving = false
    }
  },
}

export default { namespaced: true, state, mutations, actions, getters: make.getters(state) }
